import React, { Fragment } from 'react';
import { TopHeader } from '../../layout/topHeader/topHeader';

export function NotFound(props) {
  const debugInfo = props.debugInfo;

  function refreshPage(e) {
    e.preventDefault();
    if (typeof window !== `undefined`) {
      window.location.reload();
    }
  }

  function goBack(e) {
    e.preventDefault();
    if (typeof window !== `undefined`) {
      window.history.back();
    }
  }

  return (
    <Fragment>
      <TopHeader></TopHeader>
    <div className="error-panel">
      <div className="container">
        <h1>404 Error</h1>

        <p>Please <a href="/" onClick={(e) => refreshPage(e)}>refresh</a> your browser.</p>
        <div>
          <button onClick={(e) => goBack(e)}>or Go Back</button>
        </div>

        {
          debugInfo &&
          <pre style={{ marginTop: '3rem', color: 'chocolate', fontSize: '0.7rem' }}
          >Error message: {debugInfo.pageUrl} - {debugInfo.loadFrom} </pre>
        }
      </div>
    </div>
    </Fragment>

  )
}